






import VueOptions from '@utils/VueOptions'
import LineItem from './LineItem'

settings =
  name: 'AddonLineItem'

  vue:
    props: ['addon', 'actions']
    components: { LineItem }

export default VueOptions.vue settings
